import { useSelector } from "react-redux";
import { RootState } from "app/store";

const useFeatureFlag = (featureName: string): boolean | undefined => {
    const features = useSelector((state: RootState) => state.auth.configs.env);
    return features?.[featureName] === undefined ? undefined : features?.[featureName] === 'true';
  };

export default useFeatureFlag;
